jQuery(document).ready(function( $ ){
	// START JQUERY
	logit = (typeof logit !== 'undefined')? logit : false;

	// Copy to page - all options:
	// #
	// var modal_onload_enable = false; // Enable / disable modal autoload
	// var modal_onload_target = false; // Id of element to load
	// var modal_onload_autohash = true; // Load from hash

	// start by adding id of element to popon
	modal_onload_enable = (typeof modal_onload_enable !== 'undefined')? modal_onload_enable : false;
	modal_onload_target = (typeof modal_onload_target !== 'undefined')? modal_onload_target : false;
	modal_onload_autohash = (typeof modal_onload_autohash !== 'undefined')? modal_onload_autohash : true;

	// modal_onload
	if(modal_onload_enable && (modal_onload_target || modal_onload_autohash)) {

		if(modal_onload_autohash) {
				var modal_onload_hash = window.location.hash;
				if(logit == 2) console.log('[MODAL ONLOAD] Enabled HASH ' + modal_onload_hash);
				modal_onload_target = modal_onload_hash;
		} else {
				if(logit == 2) console.log('[MODAL ONLOAD] Enabled ID ' + modal_onload_target);
		}

		if($(modal_onload_target).hasClass('modal') && $(modal_onload_target).length) {
			if(logit) console.log('[MODAL ONLOAD] Opened ' + modal_onload_target);
			$(modal_onload_target).modal('show');
		} else  {
			if(logit == 2) console.log('[MODAL ONLOAD] Error. Modal not found:' + modal_onload_target);
		}
	} else {
		if(logit == 3) console.log('[MODAL ONLOAD] Disabled');
	}




	// END JQUERY
});
